module.exports = __webpack_public_path__ + "img/service-banner.e06f7019.webp";